import React from 'react';

const NaboraAbout = ({ subPath }) => {
  return (
    <div className="py-6 px-6 bg-slate-950">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-4">
          <div className="inline-flex items-center gap-3 text-cyan-400 mb-2">
            <div className="w-3 h-3 bg-cyan-400 rounded-full animate-pulse"></div>
            ✨ WHAT IS NABORA?
          </div>
          <h2 className="text-lg lg:text-xl text-gray-100 font-bold tracking-tight mb-2">Small businesses deserve big opportunities.</h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-6 items-center">
          <div className="space-y-8">
            <p className="text-lg lg:text-xl text-slate-300 leading-relaxed">
              Nabora helps neighbourhood shops, makers, women entrepreneurs, home businesses, 
              students, creators and local brands showcase products digitally, run monthly exhibitions, 
              reward buyers, and grow together.
            </p>
            
            <div className="flex flex-wrap gap-4">
              {['Powered by PurpleDoor BOS', 'FindItLocal Discovery', 'Gen Z Organizers'].map((item, i) => (
                <div key={i} className="bg-slate-900/80 backdrop-blur px-6 py-2 rounded-3xl text-sm border border-purple-500/30 flex items-center gap-2">
                  💜 {item}
                </div>
              ))}
            </div>
          </div>
          
          <div className="bg-gradient-to-br from-slate-900 to-violet-950/50 p-4 rounded-3xl border border-white/10">
            <div className="text-xl lg:text-3xl mb-4">🌟
              <span className="text-sm lg:text-lg text-slate-400 italic">
                "A vibrant digital festival for every neighbourhood"
              </span>
            </div>
            <div className="mt-4 pt-4 border-t border-white/10 text-sm uppercase tracking-widest text-purple-300">
              Not another marketplace. A community-powered ecosystem.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NaboraAbout;